module.exports = __webpack_public_path__ + "img/phone.dcbd90cb.svg";